import { SchaefflerBomItem } from '../models';
import { VitescoBomItem } from '../models/vitesco-bom-item.model';

export const defineSchaefflerBomTreeForAgGrid = (
  items: SchaefflerBomItem[],
  idx: number
): SchaefflerBomItem[] => {
  if (idx === items.length) {
    return items;
  }

  const currentItem = items[idx];
  const nextIdx = idx + 1;

  // special case level 1
  if (currentItem.level === 1) {
    currentItem.path = [currentItem.rowId];

    return defineSchaefflerBomTreeForAgGrid(items, nextIdx);
  }

  const previousItem = items[idx - 1];

  if (previousItem.level < currentItem.level) {
    // previous item is parent
    currentItem.path = [...previousItem.path, currentItem.rowId];
  } else {
    // previous item has same parent or different parent
    const itemsToRemove = previousItem.level - currentItem.level + 1;
    const predecessors = [...previousItem.path];

    // remove last items to have the actual parent as last item
    predecessors.splice(predecessors.length - itemsToRemove, itemsToRemove);

    currentItem.path = [...predecessors, currentItem.rowId];
  }

  return defineSchaefflerBomTreeForAgGrid(items, nextIdx);
};

export const defineVitescoBomTreeForAgGrid = (
  items: VitescoBomItem[]
): VitescoBomItem[] => {
  const rootByLevel = new Map<number, string>();
  for (const item of items) {
    if (
      item.assyIndicator?.toLowerCase() === 'x' &&
      !rootByLevel.has(item.level)
    ) {
      rootByLevel.set(item.level, item.rowId);
    }
  }

  const paths = new Map<string, string[]>();
  for (const item of items) {
    const path: string[] = [];

    for (let level = 0; level <= item.level; level += 1) {
      const rootId = rootByLevel.get(level);
      if (rootId === undefined) {
        break;
      }
      path.push(rootId);
    }

    if (path.at(-1) !== item.rowId) {
      path.push(item.rowId);
    }

    paths.set(item.rowId, path);
    item.path = paths.get(item.rowId);
  }

  return items;
};
